import { render, staticRenderFns } from "./DataViewSidebar.vue?vue&type=template&id=c28f9040&scoped=true"
import script from "./DataViewSidebar.vue?vue&type=script&lang=js"
export * from "./DataViewSidebar.vue?vue&type=script&lang=js"
import style0 from "./DataViewSidebar.vue?vue&type=style&index=0&id=c28f9040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28f9040",
  null
  
)

export default component.exports